import React from 'react';
import { motion } from 'motion/react';

const WhatIsSnapfy: React.FC = () => {
  return (
    <div className="my-24 relative overflow-hidden rounded-3xl bg-snapfy-surface/40 border border-snapfy-border p-8 md:p-12 lg:p-16 backdrop-blur-xl">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] bg-snapfy-primary/20 blur-[120px] rounded-full" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] bg-snapfy-accent-soft/10 blur-[120px] rounded-full" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-5xl font-black tracking-tight text-snapfy-text-primary mb-6 leading-tight">
            O futuro da criação visual para{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-snapfy-primary to-snapfy-accent-soft">
              marcas e criadores.
            </span>
          </h2>
          <p className="text-snapfy-text-secondary text-lg md:text-xl leading-relaxed mb-8">
            A Snapfy.ai é o seu estúdio criativo completo impulsionado por Inteligência Artificial.
            Crie novos produtos, explore tendências de mercado, substitua ensaios fotográficos caros
            e demorados por geração instantânea de imagens e vídeos de alta qualidade. Crie modelos
            virtuais, aplique suas roupas e produtos, e escale sua produção de conteúdo com precisão
            e realismo impressionantes.
          </p>
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm text-snapfy-text-primary font-medium">
              <span className="w-2 h-2 rounded-full bg-snapfy-primary shadow-[0_0_8px_var(--snapfy-primary)]" />
              Mais rápido
            </div>
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm text-snapfy-text-primary font-medium">
              <span className="w-2 h-2 rounded-full bg-snapfy-accent-soft shadow-[0_0_8px_var(--snapfy-accent-soft)]" />
              Mais econômico
            </div>
            <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm text-snapfy-text-primary font-medium">
              <span className="w-2 h-2 rounded-full bg-emerald-400 shadow-[0_0_8px_#34d399]" />
              100% Realista
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative"
        >
          <div className="relative aspect-[3/4] md:aspect-[4/5] lg:aspect-[3/4] rounded-2xl overflow-hidden border border-white/10 shadow-2xl group max-w-md mx-auto lg:max-w-none">
            <img
              src="https://snapfy-output.s3.us-east-1.amazonaws.com/snapfy-canvas-item-1773409023984-0.21553013792151998.png"
              alt="Snapfy.ai AI Generation"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              referrerPolicy="no-referrer"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-snapfy-primary/40 to-transparent mix-blend-overlay" />

            <div className="absolute bottom-6 left-6 right-6 bg-black/60 backdrop-blur-md border border-white/20 rounded-xl p-4 flex items-center justify-between transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-snapfy-primary to-snapfy-accent-soft flex items-center justify-center shadow-lg shadow-snapfy-primary/30">
                  <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-bold text-sm">Geração Concluída</p>
                  <p className="text-white/60 text-xs">Alta resolução • 4K</p>
                </div>
              </div>
              <div className="text-snapfy-accent-soft font-mono text-sm font-bold">100%</div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default WhatIsSnapfy;
